import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import queryString from 'query-string';
import { Provider as RollbarProvider, ErrorBoundary } from '@rollbar/react';
import { RollbarConfig } from './rollbar';
import { store } from './app/store';
import App from './App';
import FeatureFlagsPage from './components/FeatureFlagsPage';
import { initFeatureFlags } from './features/featureFlags/featureFlagsSlice';
import './custom.scss';

// Google Tag Manager is the snippet in public/index.html, so it loads
// before this bundle; the app only pushes events (see lib/analytics.ts).
const container = document.getElementById('root')!;
const root = createRoot(container);

// Flags are seeded before anything renders: the saved overrides plus the
// URL's session overrides (see features/featureFlags/flags.ts).
store.dispatch(initFeatureFlags(queryString.parse(window.location.search)));

// There is no router: the form is one page. /flags is the one other page,
// the feature-flag toggles (nginx serves index.html for every path).
const isFlagsPage = window.location.pathname.replace(/\/+$/, '') === '/flags';

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RollbarProvider config={RollbarConfig}>
        <ErrorBoundary>
          {isFlagsPage ? <FeatureFlagsPage /> : <App />}
        </ErrorBoundary>
      </RollbarProvider>
    </Provider>
  </React.StrictMode>,
);
